import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { registerGuard } from "./Guard";

const torneiRoutes: RouteRecordRaw = {
  path: "/tornei",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "",
      name: "tornei",
      component: () => import("@/views/tornei/Tornei.vue"),
    },
    {
      path: "nuovo",
      name: "tornei-nuovo",
      component: () => import("@/views/tornei/NuovoTorneo.vue"),
    },
    {
      path: "rapido",
      name: "tornei-rapido",
      component: () => import("@/views/tornei/rapido/NuovoTorneoRapido.vue"),
    },
    {
      path: "rapido/fasi/circolo/:CodiceAffiliazione",
      name: "tornei-rapido-fasi",
      component: () => import("@/views/tornei/rapido/FasiTorneoRapido.vue"),
    },
    {
      path: "rapido/modifica/:idBozza",
      name: "torneo-rapido-bozza",
      component: () => import("@/views/tornei/rapido/FasiTorneoRapido.vue"),
    },
    {
      path: "rapido/modifica/id/:id",
      name: "torneo-rapido-dettaglio",
      component: () => import("@/views/tornei/rapido/FasiTorneoRapido.vue"),
    },
    {
      path: "fasi/disciplina/:idDisciplina/circolo/:CodiceAffiliazione",
      name: "tornei-fasi",
      component: () => import("@/views/tornei/fasi/FasiTorneo.vue"),
    },
    {
      path: "modifica/:idBozza",
      name: "torneo-bozza",
      component: () => import("@/views/tornei/fasi/FasiTorneo.vue"),
    },
    {
      path: "modifica/id/:id",
      name: "torneo-dettaglio",
      component: () => import("@/views/tornei/fasi/FasiTorneo.vue"),
    },
    {
      path: "modifica-termini-iscrizione/id/:id",
      name: "torneo-dettaglio-edit-termini-iscrizione",
      component: () => import("@/views/tornei/ModificaTerminiIscrizione.vue"),
    },
    {
      path: ":idTorneo/chiusura",
      name: "tornei-chiusura",
      component: () => import("@/views/tornei/options/ChiusuraTorneo.vue"),
      props: true,
    },
    {
      path: "fasi/:idCircolo",
      name: "tornei-fasi-con-circolo",
      props: true,
      component: () => import("@/views/tornei/fasi/FasiTorneo.vue"),
    },
    {
      path: ":idTorneo/quote",
      name: "tornei-quote",
      component: () => import("@/views/tornei/options/GestioneQuote/GestioneQuote.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare",
      name: "tornei-gare",
      component: () => import("@/views/tornei/options/gare/Gare.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/nuova",
      name: "tornei-gare-nuova",
      component: () => import("@/views/tornei/options/gare/options/AggiungiGara.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara",
      name: "tornei-gare-iscritti-gara",
      component: () => import("@/views/tornei/options/gare/options/modificaIscrizioni/IscrittiGara.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/disiscritti-gara",
      name: "tornei-gare-disiscritti-gara",
      component: () => import("@/views/tornei/options/gare/options/modificaIscrizioni/DisiscrittiGara.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara/iscrizione-equiparati",
      name: "tornei-gare-iscritti-gara-iscrizione-equiparati",
      component: () => import("@/views/tornei/options/gare/options/modificaIscrizioni/IscrizioneEquiparatiGara.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara/aggiungi-giocatore",
      name: "tornei-gare-iscritti-gara-cerca-giocatori",
      component: () => import("@/views/tornei/options/gare/options/modificaIscrizioni/cercaGiocatori/CercaGiocatori.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara/iscrizione-massiva",
      name: "tornei-gare-iscritti-gara-iscrizione-massiva",
      component: () => import("@/views/tornei/options/gare/options/modificaIscrizioni/IscrizioneMassivaGiocatori.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/chiusura",
      name: "tornei-gare-chiusura",
      component: () => import("@/views/tornei/options/gare/options/ChiusuraGara.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara/pagamento/:idUser",
      name: "tornei-gare-pagamento",
      component: () => import("@/components/gestione-gare/Pagamento.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara/desiderata/:idUser",
      name: "tornei-gare-desiderata",
      component: () => import("@/components/gestione-gare/Desiderata.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/iscritti-gara/contatti/:idUser",
      name: "tornei-gare-contatti",
      component: () => import("@/components/gestione-gare/Contatti.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni",
      name: "tornei-gare-modifica-sezioni",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/Sezioni.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/gironi",
      name: "tornei-gare-sezioni-gironi",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/gironi/SezioniGironi.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/gironi/nuovo",
      name: "tornei-gare-sezioni-gironi-new",
      component: () => import("@/components/tornei/SezioniGironi/nuovoGirone/NuovoGirone.vue"),
      props: true,
    },
        {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/gironi/modifica",
      name: "tornei-gare-sezioni-gironi-edit",
      component: () => import("@/components/tornei/SezioniGironi/nuovoGirone/ModificaGirone.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/iscritti/:idTipologiaSezione",
      name: "tornei-gare-iscrittiSezione",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/iscritti/IscrittiSezione.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/tabellone",
      name: "tornei-gare-modifica-sezioni-tabellone",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/tabellone/Tabellone.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/tabellone/genera",
      name: "tornei-gare-modifica-sezioni-tabellone-new",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/tabellone/CreazioneTabellone.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/tabellone/risultati",
      name: "tornei-gare-modifica-sezioni-tabellone-results",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/tabellone/RisultatiTabellone.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/gironi/risultati",
      name: "tornei-gare-modifica-sezioni-gironi-results",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/gironi/RisultatiGiorni.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/sezioni/:idSezione/tabellone/categorie",
      name: "tornei-gare-modifica-sezioni-tabellone-categories",
      component: () => import("@/views/tornei/options/gare/options/modificaSezione/options/tabellone/TabelloneCategorie.vue"),
      props: true,
    },
    {
      path: ":idTorneo/gare/:idGara/registro-attivita",
      name: "tornei-gare-registro-attivita",
      component: () => import("@/views/tornei/options/gare/RegistroAttivitaGareTorneo.vue"),
      props: true,
    },
    {
      path: ":idTorneo/direttore-gara",
      name: "tornei-direttore-gara",
      component: () => import("@/views/tornei/options/direttoreDiGara/DirettoreDiGara.vue"),
    },
    {
      path: ":idTorneo/ufficiale-gara",
      name: "tornei-ufficiale-gara",
      component: () => import("@/views/tornei/options/ufficialeDiGaraFederale/UfficialeDiGaraFederale.vue"),
    },
    {
      path: ":idTorneo/ufficiali-gara-assistenti",
      name: "tornei-ufficiali-gara-assistenti",
      props: true,
      component: () => import("@/views/tornei/options/ufficialiDiGaraAssistenti/UfficialiDiGaraAssistenti.vue"),
    },
    {
      path: ":idTorneo/orari-di-gioco",
      name: "tornei-orari-di-gioco",
      component: () => import("@/views/tornei/options/orariDiGioco/OrariDiGioco.vue"),
    },
    {
      path: ":idTorneo/registro-attivita",
      name: "tornei-registro-attivita",
      component: () => import("@/views/tornei/options/RegistroAttivitaTorneo.vue"),
    },
    {
      path: ":idTorneo/giustificativi-giocatori-assenti",
      name: "tornei-giustificativi-giocatori-assenti",
      component: () => import("@/views/tornei/options/GiustificativiGiocatoriAssenti.vue"),
    },
  ],
};

const gareASquadreRoutes: RouteRecordRaw = {
  path: "/gare-a-squadre",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "",
      name: "gare-a-squadre",
      component: () => import("@/views/gare-a-squadre/GareASquadre.vue"),
    },
    {
      path: "nuovo",
      name: "gare-a-squadre-nuovo",
      component: () => import("@/views/gare-a-squadre/NuovaGaraASquadre.vue"),
    },
    {
      path: ":idGara/modifica",
      name: "gare-a-squadre-modifica",
      component: () => import("@/views/gare-a-squadre/options/ModificaGaraASquadre.vue"),
    },
    {
      path: ":idGara/iscrizioni",
      name: "gare-a-squadre-iscrizioni",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/IscrizioniSquadre.vue"),
    },
    {
      path: ":idGara/iscrizioni/:idSquadra/ufficiale-gara-federale",
      name: "gare-a-squadre-iscrizioni-ufficiale-gara-federale",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/options/UfficialeDiGaraFederale.vue"),
    },
    {
      path: ":idGara/iscrizioni/nuovo/:idCircolo?",
      name: "gare-a-squadre-iscrizioni-nuovo",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/NuovaIscrizioneSquadra.vue"),
    },
    {
      path: ":idGara/iscrizioni/da-altre-gare",
      name: "gare-a-squadre-iscrizioni-da-altre-gare",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/IscrizioneDaAltreGare.vue"),
    },
    {
      path: ":idGara/iscrizioni/:idSquadra/modifica",
      name: "gare-a-squadre-iscrizioni-modifica",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/ModificaIscrizioneSquadra.vue"),
    },
    {
      path: ":idGara/iscrizioni/:idSquadra/iscritti",
      name: "gare-a-squadre-iscrizioni-iscritti",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/options/IscrittiGareASquadre.vue"),
      props: true,
    },
    {
      path: ":idGara/iscrizioni/iscritti/:idSquadra/aggiungi-giocatore",
      name: "gare-a-squadre-iscritti-gara-aggiungi-giocatore",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/AggiungiGiocatore.vue"),
      props: true,
    },
    {
      path: ":idGara/iscrizioni/iscritti/:idSquadra/aggiungi-prestito",
      name: "gare-a-squadre-iscritti-gara-aggiungi-prestito",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/AggiungiPrestito.vue"),
      props: true,
    },
    {
      path: ":idGara/iscrizioni/iscritti/:idSquadra/iscrizione-massiva",
      name: "gare-a-squadre-iscritti-gara-iscrizione-massiva",
      component: () => import("@/views/gare-a-squadre/options/visualizzaIscrizioniGara/IscrizioneMassivaGiocatoriGare.vue"),
      props: true,
    },
    {
      path: ":idGara/fasi",
      name: "gare-a-squadre-fasi",
      component: () => import("@/views/gare-a-squadre/options/fasiGironi/FasiGaraASquadre.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/genera-gironi",
      name: "gare-a-squadre-genera-gironi",
      component: () => import("@/views/gare-a-squadre/GeneraGironiGaraASquadre.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/calendario",
      name: "gare-a-squadre-calendario",
      component: () => import("@/views/gare-a-squadre/CalendarioGaraASquadre.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/incontri",
      name: "gare-a-squadre-incontri",
      component: () => import("@/views/gare-a-squadre/IncontriGaraASquadre.vue"),
      props: true,
    },
    {
      path: ":idGara/fasi/:idFase/incontri/:idIncontro/dettaglio",
      name: "gare-a-squadre-incontri-dettaglio",
      component: () => import("@/views/gare-a-squadre/options/fasiGironi/options/DettaglioIncontri.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/incontri/:idIncontro/dettaglio/nuovo",
      name: "gare-a-squadre-incontri-dettaglio-nuovo",
      component: () => import("@/views/gare-a-squadre/options/fasiGironi/options/NuovoDettaglioIncontro.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/incontri/:idIncontro/dettaglio/modifica",
      name: "gare-a-squadre-incontri-dettaglio-modifica",
      component: () => import("@/views/gare-a-squadre/options/fasiGironi/options/ModificaDettaglioIncontro.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/incontri/:idSquadra/componenti-squadra",
      name: "gare-a-squadre-incontri-componenti-squadra",
      component: () => import("@/views/gare-a-squadre/ComponentiSquadraIncontri.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/incontri/:idIncontro/gestione",
      name: "gare-a-squadre-incontri-gestione",
      component: () => import("@/views/gare-a-squadre/options/fasiGironi/options/GestioneIncontro.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/incontri/:idIncontro/referto",
      name: "gare-a-squadre-incontri-referto",
      component: () => import("@/views/gare-a-squadre/options/fasiGironi/options/RefertoIncontro.vue"),
    },
    {
      path: ":idGara/fasi/:idFase/tabellone",
      name: "gare-a-squadre-tabellone-fase",
      component: () => import("@/views/gare-a-squadre/VisualizzaTabelloneFase.vue"),
    },
  ],
};

const calcoloClassificheBackOfficeRoutes: RouteRecordRaw = {
  path: "/calcoli-classifiche",
  children: [
    {
      path: "acquisizione-punti",
      name: "calcoli-classifiche-acquisizione-punti",
      component: () => import("@/views/backoffice/calcoli-classifiche/AcquisizionePunti.vue"),
    },
    {
      path: "armonizzazione",
      name: "calcoli-classifiche-armonizzazione",
      component: () => import("@/views/backoffice/calcoli-classifiche/Armonizzazione.vue"),
    },
    {
      path: "bonus-campionati",
      name: "calcoli-classifiche-bonus-campionati",
      component: () => import("@/views/backoffice/calcoli-classifiche/BonusCampionati.vue"),
    },
    {
      path: "bonus-assenzasconfitte",
      name: "calcoli-classifiche-bonus-mancanze-sconfitte-assenze",
      component: () => import("@/views/backoffice/calcoli-classifiche/BonusMancanzeSconfitteAssenze.vue"),
    },
    {
      path: "bonus-vittorietornei",
      name: "calcoli-classifiche-bonus-vittorie-tornei",
      component: () => import("@/views/backoffice/calcoli-classifiche/BonusVittorieTornei.vue"),
    },
    {
      path: "categorie-classifiche-fed-estere",
      name: "calcoli-classifiche-categorie-classifiche-federazioni-estere",
      component: () => import("@/views/backoffice/calcoli-classifiche/CategorieClassificheFederazioniEstere.vue"),
    },
    {
      path: "qualifiche-nazionali",
      name: "calcoli-classifiche-qualifiche-nazionali",
      component: () => import("@/views/backoffice/calcoli-classifiche/QualificheNazionali.vue"),
    },
    {
      path: "numeri-base-vittorie",
      name: "calcoli-classifiche-numeri-base-vittorie",
      component: () => import("@/views/backoffice/calcoli-classifiche/NumeriBaseVittorie.vue"),
    },
    {
      path: "precedenti-classifiche",
      name: "calcoli-classifiche-precedenti-classifiche-federali",
      component: () => import("@/views/backoffice/calcoli-classifiche/PrecedentiClassificheFederali.vue"),
    },
    {
      path: "promozioni-retrocessioni",
      name: "calcoli-classifiche-promozioni-retrocessioni",
      component: () => import("@/views/backoffice/calcoli-classifiche/PromozioniRetrocessioni.vue"),
    },
    {
      path: "punti-decurtazioni-armonizzazioni",
      name: "calcoli-classifiche-punti-decurtazioni-armonizzazioni",
      component: () => import("@/views/backoffice/calcoli-classifiche/PuntiDecurtazioniArmonizzazioni.vue"),
    },
    {
      path: "valutazioni-classifiche-internazionali",
      name: "calcoli-classifiche-valutazioni-classifiche-internazionali",
      component: () => import("@/views/backoffice/calcoli-classifiche/ValutazioniClassificheInternazionali.vue"),
    },
    {
      path: "vittorie-supplementari",
      name: "calcoli-classifiche-vittorie-supplementari",
      component: () => import("@/views/backoffice/calcoli-classifiche/VittorieSupplementari.vue"),
    },
  ],
};

const manifestazioniRoutes: RouteRecordRaw = {
  path: "/manifestazioni",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "",
      name: "manifestazioni",
      component: () => import("@/views/manifestazioni/Manifestazioni.vue"),
    },
    {
      path: "nuova",
      name: "manifestazioni-new",
      component: () => import("@/views/manifestazioni/NuovaManifestazione.vue"),
    },
    {
      path: ":idManifestazione",
      name: "manifestazioni-edit",
      component: () => import("@/views/manifestazioni/options/ModificaManifestazione.vue"),
    },
    {
      path: ":idManifestazione/gare",
      name: "manifestazioni-gare",
      component: () => import("@/views/manifestazioni/options/Gare.vue"),
    },
    {
      path: ":idManifestazione/gare/nuova",
      name: "manifestazioni-gare-new",
      component: () => import("@/views/manifestazioni/options/NuovaGara.vue"),
    },
    {
      path: ":idManifestazione/gare/:idGaraManifestazione/modifica",
      name: "manifestazioni-gare-edit",
      component: () => import("@/views/manifestazioni/options/options/ModificaGara.vue"),
    },
    {
      path: ":idManifestazione/gare/:idGaraManifestazione/partite",
      name: "manifestazioni-partite",
      component: () => import("@/views/manifestazioni/options/Partite.vue"),
    },
  ],
};

const backofficeQuoteTasseRoutes: RouteRecordRaw = {
  path: "/quote-tasse",
  children: [
    {
      path: "quote-gare-squadre",
      name: "bo-qt-quota-gare-a-squadre",
      component: () => import("@/views/backoffice/quote-tasse/QuoteGareSquadre.vue"),
    },
    {
      path: "quote-iscrizioni-giocatori",
      name: "bo-qt-quota-iscrizione-giocatore",
      component: () => import("@/views/backoffice/quote-tasse/QuotaIscrizioneGiocatore.vue"),
    },
    {
      path: "tasse-approvazione-tornei",
      name: "bo-qt-tassa-approvazione-torneo",
      component: () => import("@/views/backoffice/quote-tasse/TassaApprovazioneTorneo.vue"),
    },
    {
      path: "tasse-iscrizioni giocatori",
      name: "bo-qt-tassa-iscrizione-giocatore",
      component: () => import("@/views/backoffice/quote-tasse/TassaIscrizioneGiocatore.vue"),
    },
  ],
};

const backofficeRoutes: RouteRecordRaw = {
  path: "/backoffice",
  component: () => import("@/layout/Layout.vue"),
  children: [
    calcoloClassificheBackOfficeRoutes,
    backofficeQuoteTasseRoutes,
    {
      path: "circuiti",
      name: "backoffice-circuiti",
      component: () => import("@/views/Circuiti.vue"),
    },
    {
      path: "palle",
      name: "backoffice-palle",
      component: () => import("@/views/backoffice/Palle.vue"),
    },
    {
      path: "superfici",
      name: "backoffice-superfici",
      component: () => import("@/views/backoffice/Superfici.vue"),
    },
    {
      path: "aree-regionali",
      name: "backoffice-aree-regionali",
      component: () => import("@/views/backoffice/AreaRegionaleGareASquadre.vue"),
    },
    {
      path: "config-tornei-internazionali",
      name: "backoffice-configurazione-tornei-internazionali",
      component: () => import("@/views/backoffice/ConfigurazioneTorneiInternazionali.vue"),
    },
    {
      path: "config-vittorie-internazionali",
      name: "backoffice-configurazione-vittorie-internazionali",
      component: () => import("@/views/backoffice/ConfigurazioneVittorieInternazionali.vue"),
    },
    {
      path: "categorie-classifica",
      name: "backoffice-categorie-classifica",
      component: () => import("@/views/backoffice/CategorieClassifica.vue"),
    },
    {
      path: "massimali",
      name: "backoffice-massimali-circoli",
      component: () => import("@/views/backoffice/MassimaliCircoli.vue"),
    },
    {
      path: "serie-gare-a-squadre",
      name: "backoffice-serie-gare-a-squadre",
      component: () => import("@/views/backoffice/SerieGareASquadre.vue"),
    },
    {
      path: "serie-gare-a-squadre/edit",
      name: "backoffice-serie-gare-a-squadre-edit",
      component: () => import("@/components/backoffice/serie-gare-a-squadre/new/EditSerieGareSquadre.vue"),
    },
    {
      path: "stagioni-sportive",
      name: "backoffice-stagioni-sportive",
      component: () => import("@/views/backoffice/StagioniSportive.vue"),
    },
    {
      path: "tipologie-tornei",
      name: "backoffice-tipologie-tornei",
      component: () => import("@/views/backoffice/TipologieTornei.vue"),
    },
    {
      path: "tipologie-incontri",
      name: "backoffice-tipologie-incontri",
      component: () => import("@/views/backoffice/TipologieIncontri.vue"),
    },
    {
      path: "equiparati",
      name: "backoffice-tesserati-equiparati",
      component: () => import("@/views/backoffice/TesseratiEquiparati.vue"),
    },
    {
      path: "causali",
      name: "backoffice-causali",
      component: () => import("@/views/backoffice/Causali.vue"),
    },
    {
      path: "qualifiche-albo-nazionale",
      name: "backoffice-qualifiche-albo-nazionale",
      component: () => import("@/views/backoffice/QualificheAlboNazionale.vue"),
    },
  ],
};

const classificheSchedaAttivitaRoutes: RouteRecordRaw = {
  path: "/classifiche/scheda-attivita",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "",
      name: "classifiche-scheda-attivita",
      component: () => import("@/views/classifiche-scheda-attivita/ClassificheSchedaAttivita.vue"),
    },
    {
      path: "dettaglio",
      name: "classifiche-scheda-attivita-dettaglio",
      component: () => import("@/views/classifiche-scheda-attivita/DettaglioClassificaSchedaAttivita.vue"),
    },
  ],
};

const reportRoutes: RouteRecordRaw = {
  path: "/report",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "ricerca-iscrizioni-giocatori",
      name: "report-iscrizioni-giocatori",
      component: () => import("@/views/report/ReportIscrizioniGiocatori.vue"),
    },
    {
      path: "ricerca-iscrizioni-giocatori/dettaglio",
      name: "report-iscrizioni-giocatori-dettaglio",
      component: () => import("@/views/report/DettaglioIscrizioniGiocatore.vue"),
    },
    {
      path: "ricerca-squadre-circolo",
      name: "report-ricerca-squadre-circolo",
      component: () => import("@/views/report/RicercaSquadreCircolo.vue"),
    },
    {
      path: "ricerca-squadre-circolo/dettaglio",
      name: "report-ricerca-squadre-circolo-dettaglio",
      component: () => import("@/views/report/DettaglioRicercaSquadreCircolo.vue"),
    },
  ],
};

/* const attivitaInternazionaliRoutes: RouteRecordRaw = {
  path: "/attivita-internazionali",
  component: () => import("@/layout/Layout.vue"),
  children: [
    {
      path: "",
      name: "attivita-internazionali",
      component: () => import("@/views/attivita-internazionali/AttivitaInternazionali.vue"),
    },
    {
      path: "aggiungi",
      name: "attivita-internazionali-aggiungi",
      component: () => import("@/views/attivita-internazionali/CercaGiocatoreAttivita.vue"),
    },
    {
      path: "aggiungi/dettaglio",
      name: "attivita-internazionali-aggiungi-dettaglio",
      component: () => import("@/views/attivita-internazionali/AggiungiAttivitaInternazionale.vue"),
    },
    {
      path: "aggiunta-massiva",
      name: "attivita-internazionali-aggiunta-massiva",
      component: () => import("@/views/attivita-internazionali/AggiuntaMassivaAttivita.vue"),
    },
  ],
}; */

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    component: () => import("@/layout/Layout.vue"),
    children: [
      {
        path: "help-desk",
        name: "help-desk",
        component: () => import("@/views/HelpDesk.vue"),
      },
    ],
  },
  torneiRoutes,
  backofficeRoutes,
  gareASquadreRoutes,
  manifestazioniRoutes,
  classificheSchedaAttivitaRoutes,
  reportRoutes,
  //attivitaInternazionaliRoutes,
  // {
  //   path: "/help-desk",
  //   component: () => import("@/layout/Layout.vue"),

  // },
  {
    path: "/404",
    name: "404",
    component: () => import("@/views/errors/Error404.vue"),
  },
  {
    path: "/non-autorizzato",
    name: "non-autorizzato",
    component: () => import("@/views/errors/NonAutorizzato.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(() => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

router.onError(error => {
  window.location.reload();
});

registerGuard(router);

export default router;
